import { render, staticRenderFns } from "./ProFolderCard.vue?vue&type=template&id=41e03063&"
import script from "./ProFolderCard.vue?vue&type=script&lang=ts&"
export * from "./ProFolderCard.vue?vue&type=script&lang=ts&"
import style0 from "./ProFolderCard.vue?vue&type=style&index=0&id=41e03063&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports